/**
 * The MRP page's views: the plan, the buy list, the recipes the plan explodes
 * through, and what the run could not find. The Material Plan and POs to Place
 * read the selected MRP run; the BOM Explorer is core's embed over the sourcing BOM,
 * which reads no run. The others are on the bar, named, so the page already has
 * the shape it will keep; each becomes a view by losing its `disabled` line.
 *
 * The tab rides on the path, as this app's other pages' tabs do (Replenishment:
 * /sparkling/production). The explorer's own state — the open item — rides
 * beside it as `?item=`.
 */

export const MRP_BASE_PATH = "/mrp";

export interface MrpTab {
  id: string;
  label: string;
  path: string;
  /** On the bar, named, but not yet a view: drawn disabled, nothing routed. */
  disabled?: boolean;
}

export const MRP_TABS: readonly MrpTab[] = [
  { id: "plan", label: "Material Plan", path: `${MRP_BASE_PATH}/plan` },
  { id: "pos-to-place", label: "POs to Place", path: `${MRP_BASE_PATH}/pos-to-place` },
  { id: "bom-explorer", label: "BOM Explorer", path: `${MRP_BASE_PATH}/bom-explorer` },
  { id: "data-gaps", label: "Data Gaps", path: `${MRP_BASE_PATH}/data-gaps` },
];

export const MATERIAL_PLAN_TAB = "plan";
export const POS_TO_PLACE_TAB = "pos-to-place";
export const BOM_EXPLORER_TAB = "bom-explorer";
export const DATA_GAPS_TAB = "data-gaps";

/** Where /mrp opens: the first live tab. */
export const DEFAULT_TAB: MrpTab = MRP_TABS.find((t) => !t.disabled) ?? MRP_TABS[0];

/** The live tab a path shows, or the default: /mrp itself, a disabled tab's
 *  address and an unknown /mrp/<x> all open the page rather than nowhere. */
export const mrpTabAt = (pathname: string): MrpTab =>
  MRP_TABS.find((t) => !t.disabled && (pathname === t.path || pathname.startsWith(`${t.path}/`))) ?? DEFAULT_TAB;
